import { Navigate } from 'react-router-dom';

function RutaProtegida({ children }) {
  const usuario = localStorage.getItem('usuario');
  return usuario ? children : <Navigate to="/" replace />;
}

export default RutaProtegida;
